import CreateTaskTags from "@/components/CreateTaskTags/createTaskTags.component";
import TaskCellTagsNotEditing from "@/components/SingleLineTask/SingleLineTaskCells/taskCellTagsNotEditing.component";
import { NewTaskTag, Tag } from "@/types";
import React from "react";

type TaskCellTagsProps = {
  className: string;
  editing: boolean;
  taskTags: Tag[];
  editedTags?: NewTaskTag[];
  selectedEditableTaskTags?: NewTaskTag[];
  handleFieldTags?(newTag: NewTaskTag): void;
  createTagOpen?: React.MutableRefObject<boolean>;
};

const TaskCellTags: React.FC<TaskCellTagsProps> = ({
  className,
  editing,
  editedTags,
  taskTags,
  selectedEditableTaskTags,
  handleFieldTags,
  createTagOpen,
}) => {
  return editing && editedTags && handleFieldTags ? (
    <div className={className}>
      <CreateTaskTags
        id="edit-tags"
        taskTags={editedTags}
        handleFieldTags={handleFieldTags}
        side="bottom"
        createTagOpen={createTagOpen}
        createTagAllowed={true}
      />
    </div>
  ) : (
    <div className={className}>
      <TaskCellTagsNotEditing
        taskTags={taskTags}
        selectedEditableTaskTags={selectedEditableTaskTags}
      />
    </div>
  );
};

export default TaskCellTags;
